import VanityCabinetSubPartCommon from "./vanityCabinetSubPartCommon";
import {Vanity} from "../../parts/vanity";
import {VANITY_TYPES} from "../../constants";

export default class VanityMiddle extends VanityCabinetSubPartCommon {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_middle';
    this.partName = 'Vanity Middle';
    this.translateId = "visualizer.bathroom.vanity.vanity_middle";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    this.isStoneFeature = true;
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityCabinet
      || !vanityParent.vanityCabinet.activeFeature
      || vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet
      || (vanityParent.vanityCabinet.layerPositions && vanityParent.vanityCabinet.layerPositions["C"])
      || (this.activeFeature && !this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const activeMatchingVanity = this.getParent().getActiveSkuFromRelatedItem("vanity_cabinet");
    if (activeMatchingVanity) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: activeMatchingVanity
      });
    }
    return conditions
  }

  canDisplayDemoPoint() {
    return this.getParent().vanity_type === VANITY_TYPES.vanity_cabinet
  }

}
